/**
 * Выключатель «Новогодней ёлки 3D» на клиенте. Продукт пока виден только локально.
 * Включено, если сборка dev (`vite`), страница открыта на локальном хосте
 * (localhost, 127.0.0.1, [::1], *.localhost) или собрано с VITE_NEW_YEAR_TREE_3D=true.
 * Серверная пара — NEW_YEAR_TREE_3D_ENABLED (server/src/config/new-year-tree-3d.ts).
 */
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]', '::1']);

function isLocalHost(): boolean {
  if (typeof window === 'undefined') return false;
  const host = String(window.location.hostname ?? '').toLowerCase();
  return LOCAL_HOSTS.has(host) || host.endsWith('.localhost');
}

export function isNewYearTree3dEnabled(): boolean {
  return Boolean(import.meta.env.DEV) || import.meta.env.VITE_NEW_YEAR_TREE_3D === 'true' || isLocalHost();
}
